/* @flow */

import React from 'react';
import glamorous, { Div } from 'glamorous';
import { position } from 'polished';

type Props = {
  children: any,
  ratio: number,
};

const Inner = glamorous.div(position('absolute', '0'));

function FixedDimensionRatio({
  children,
  ratio,
}: Props) {
  return (
    <Div paddingTop={`${100 / ratio}%`} position="relative">
      <Inner>
        {children}
      </Inner>
    </Div>
  );
}

export default FixedDimensionRatio;
